import styled from 'styled-components';

export const StyledSafetyTraining = styled.div`
  width: 100%;
  max-height: 60vh;
  min-height: 40vh;
  overflow-y: auto;
  padding: 24px 28px;

  .st-wrapper {
    margin-bottom: 16px;

    .ba-label {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      min-width: 82px !important;
      margin-bottom: 0 !important;
    }
  }

  .st-table {
    > div {
      > .MuiTableContainer-root {
        max-height: calc(600px - 60px);
      }
    }
  }
`;

export const StyledInfoBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  > div {
    width: 50%;
    margin-bottom: 0;
  }
`;
